// export const API_URL = "http://65.1.111.174:8080/"
export const API_URL = "https://ghumnejao.com/administration/"
// export const API_URL = "http://localhost:8080/administration/";

export const categoryapi="admin/api/package-types/all"

export const contactapi = "admin/api/contacts"

export const packagesApi = "admin/api/packages-type/"

export const blogApi = "admin/api/blogs"

export const blogdetailApi = "admin/api/blog/detail/"

export const packagedetailsApi = "admin/api/packages/"

export const bannerApi = "admin/api/banners"
export const homepackageApi = "admin/api/combined-packages/"

// export const ImgUrl = "https://65.1.111.174:8080/"
export const ImgUrl = "https://ghumnejao.com/administration/"
// export const ImgUrl = "http://localhost:8080/administration/"
export const blogImgUrl = "uploads/blog/"
export const packageImgUrl = "uploads/packages/"
export const bannerImgUrl = "/uploads/banners/"
export const destinationImgUrl = "uploads/abc/";
export const themeImgUrl = "uploads/themes/"; 
export const referencePackageImgUrl = "uploads/packages/";